import { BillingAddress } from './../../models/customer.model';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedDataService } from 'app/services/sharedData.service';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { UserService } from 'app/users/user.service';
import { OrderService } from 'app/services/order.service';
import { CreateOrderAccess, CreateOrderAddr, CreateOrderLine, CreateOrderRequest, LineUpdate, OrderTotalDtls, Participant, ProductDetails, ProductDtls, ProductDtlsForReview, ProductName, RenewOrderRequest, TierName, UpdateOrderRequest } from 'app/models/products.model';
import { environment } from 'environments/environment';
import { AuthService, Passport } from 'app/services/auth.service';
import { TrackingService, AbandonCartEvents, AbandonCartDataKeys as DataKeys} from 'app/services/tracking.service';

import * as uuid from 'uuid';

@Component({
  selector: 'app-order-review',
  templateUrl: './order-review.component.html',
  styleUrls: ['./order-review.component.scss']
})

export class OrderReviewComponent implements OnInit {

  @ViewChild('paymentTermsDialog') paymentTermsDialog!: TemplateRef<any>;
  prodDetails: any = {};
  prodList: ProductDtlsForReview[] = [];
  orderAmt1: any = {};
  orderAmt: any = {};
  productId!: string;
  disableNextBtn: boolean = true;
  acceptTerms: boolean = false;
  termsDialogRef!: MatDialogRef<any, any>;
  termsChecked:boolean = false;
  selectedQuantity: number = 0;
  membership: string = TierName.NONMBR;
  products: [{[key: string]: ProductDtls}] = [{}];
  customerNumber!: string;
  preCreateOrderReqObj!: CreateOrderRequest|null;
  showSpinner: boolean = true;
  orderNumber!: string;
  hasErrors: boolean = false;
  isRenewalOrder: boolean = false;
  renewalAgreementId !: string;
  renewalQuantity !: number;
  renewalItemNumber !: string;
  userEmail?: string;

  constructor(
    private dialog: MatDialog,
    private sharedDataService: SharedDataService,
    private userService: UserService,
    private orderService: OrderService,
    private alertService: AlertsService,
    private authService: AuthService ,
    private trackingService: TrackingService
    
  ) {}

  ngOnInit() {
    let token: Passport  = {
      id: uuid.v4(),
      userFlow: 'review',
      customerNumber: this.userService.profile.customerNumber
    }
    this.authService.getToken(token).subscribe();
    this.retrieveDetails();
  }

  retrieveDetails() {
    this.products = this.sharedDataService.cartProducts;
    if(!this.products)
      this.checkItemsInCart();
    this.orderNumber = this.sharedDataService.orderNumber;
    this.checkAndGetDetailsOfRenewalOrder();
    if(this.orderNumber) {
      this.updateOrder();
    } else {
      if(!this.isRenewalOrder)
        this.createOrder();
      else
        this.renewOrder();
    } 
    
  }

  createOrder() {
    this.preCreateOrderReqObj = this.preCreateOrder();
    if(this.preCreateOrderReqObj != null) {
      let requestBody:Partial<CreateOrderRequest> = {};
      Object.assign (requestBody, this.preCreateOrderReqObj);
      //call createOrder service
      this.orderService.createOrder(requestBody).subscribe({
        next: (data: any) => {
          if(data) {
            this.retrieveDataFromResponse(data);
          } else {
            this.alertService.displayError("Error occured while calling create order, no data returned");
            this.hasErrors = true;
            this.showSpinner = false;
          }
        },
        error: err => {
          this.alertService.displayError(this.parseErrorMessage(err.error.ErrorMessage));
          console.log("Error occured while calling create order to Advantage" + this.parseErrorMessage(err.error.ErrorMessage));
          this.hasErrors = true;
          this.showSpinner = false;
        }
      }); 
    }
  }

  retrieveDataFromResponse(data: any) { 
    if(data.Data) {
      this.orderNumber = data.Data.OrderNumber;
      this.sharedDataService.setOrderNumber(this.orderNumber, false);
      if(data.Data.Amounts) {
        let orderDtls : OrderTotalDtls = {
          subTotal: data.Data.Amounts.TotalSalesAmount,
          tax: data.Data.Amounts.SalesTax,
          orderTotal: data.Data.Amounts.TotalCost,
          promoDiscount: data.Data.Amounts.TotalDiscount
        };
        Object.assign(this.orderAmt, orderDtls);
      }
      if(data.Data.Lines) {
        for(var line of data.Data.Lines) {
          var itemNumber = line.ItemNumber;
          const prod = this.products.find( (p) => Object.keys(p)[0] === itemNumber);
          let prodObj : ProductDtlsForReview = {
            itemNumber: itemNumber,
            lineNumber: line.LineNumber,
            productName: ProductName[itemNumber],
            quantity: line.QuantityOrdered,
            term: line.Access?.ServicePeriodCode? line.Access?.ServicePeriodCode.substring(2).replace(/0/gi,''): '',
            startDate: this.isRenewalOrder ? (prod? prod[itemNumber]?.renewalStartDate :new Date().toLocaleDateString())
              : new Date().toLocaleDateString(),
            endDate: new Date(line.Access.FinalExpire).toLocaleDateString()
          };
          this.prodList.push(prodObj);
        }
        this.sharedDataService.setOrderReviewItems(this.prodList, false);
        this.showSpinner = false;
      }
      if(data.Data.BillTo) {
        this.userEmail = data.Data.BillTo.EmailAddress;
      }
    } else {
      if(data.ErrorMessage) {
        let msg: string = data.ErrorMessage;
        let errMsg = this.parseErrorMessage(msg); //msg.substring(msg.lastIndexOf(`,\"Message\":\"`)+12, msg.lastIndexOf(`\",\"WorkerId\"`));
        this.alertService.displayError(errMsg);
        this.hasErrors = true;
        this.showSpinner = false;
      }
    }
    this.updateTrackingInfo();
  }

  checkItemsInCart() {
    var prods = sessionStorage.getItem("cartProducts");
    if(prods) {
      this.products = JSON.parse(prods);}
  }

  parseErrorMessage(msg: string): string {
    return msg.substring(msg.lastIndexOf(`,\"Message\":\"`)+12, msg.lastIndexOf(`\",\"WorkerId\"`));
  }

  preCreateOrder(): CreateOrderRequest|null {
    this.membership = this.userService.isInGroup('member') ? TierName.MEMBER : TierName.NONMBR;
    this.customerNumber = this.userService.profile.customerNumber;
    let itemNumber, quantity, servicePeriodCode;
    let promoCode = this.sharedDataService.promoCodes ? this.sharedDataService.promoCodes[0] : '';
    if(this.products) {
      let orderLines : CreateOrderLine[] = [];
      for (var product of this.products) {
        itemNumber = Object.keys(product)[0];
        quantity = product[itemNumber].quantity;
        servicePeriodCode = product[itemNumber].servicePeriodCode;
        let orderLine = this.createOrderLine(itemNumber, quantity, servicePeriodCode, promoCode);
        orderLines.push(orderLine);
      }
      let req : CreateOrderRequest = {
        Username : '',
        OrderSourceCode : 'OCMWEB',
        BillTo: this.createOrderAddressCode(),
        ShipTo: this.createOrderAddressCode(),
        Lines: orderLines,
        InstallmentBillingCode: '',
        FreeShipping: true,
        DiscountPercent: 0,
        PurchaseOrderNumber: '',
        PromotionCode: '', //leaving this empty as promocode is applied on line item level
        CurrencyCode: 'US$' 
      }
      return req;
    }
    return null;
  }

  updateOrder() {
    let list = this.sharedDataService.orderReviewItems;
    if(!list) {
      var lsList = sessionStorage.getItem('reviewItems');
      if(lsList)
        list = JSON.parse(lsList);
    }
    if(!list && this.isRenewalOrder) {
      let renewDtls : ProductDtlsForReview = {
        itemNumber : this.renewalItemNumber,
        quantity : this.renewalQuantity
      }
      list = [renewDtls];
    }
    //create request
    if(list) {
      let lineUpdates: LineUpdate[] = [];
      let promoCode = this.sharedDataService.promoCodeForUpdate;
      for(var prod of list) {
        let itemNbr = prod.itemNumber? prod.itemNumber: '';
        const product = this.products.find( (p) => Object.keys(p)[0] === itemNbr);
        let lineReq: LineUpdate = {
          ItemNumber : itemNbr,
          Quantity: product? product[itemNbr]?.quantity : 0,
        }
        if(promoCode)
          lineReq.PromotionCode = promoCode;
        lineUpdates.push(lineReq);
      }
      let request: UpdateOrderRequest = {
        LineUpdates : lineUpdates
      }
      //console.log('Update request '+ JSON.stringify(request))
      //call update order service
      this.orderService.updateOrder(this.orderNumber, request).subscribe({
        next: (data: any) => {
          if(data) {
            //console.log('Update Order call successful. Data - ' + JSON.stringify(data))
            this.retrieveDataFromResponse(data);
          } else {
            this.alertService.displayError("Error occured while calling update order, no data returned");
            this.hasErrors = true;
            this.showSpinner = false;
          }
        },
        error: err => {
          this.alertService.displayError(this.parseErrorMessage(err.error.ErrorMessage));
          console.log('Error occured while calling update order to Advantage ' + this.parseErrorMessage(err.error.ErrorMessage))
          this.hasErrors = true;
          this.showSpinner = false;
        }
      });
     } else {
      console.log('no data to call update order, so call create order instead')
      if(!this.isRenewalOrder)
        this.createOrder();
      else
        this.renewOrder();
    }
  }

  createOrderAddressCode(): CreateOrderAddr {
    let obj: CreateOrderAddr = {
      AddressCode : 'WBILL',
      CustomerNumber : this.customerNumber
    };
    return obj;
  }

  createOrderLine(itemNumber: string, quantity: number, servicePeriodCode: string, promoCode: string): CreateOrderLine {
    let obj: CreateOrderLine = {
      ItemNumber: itemNumber,
      Quantity: quantity,
      PromotionCode: promoCode,
      PromotionChoiceCode: '',
      PriceCode: this.membership,
      ShipTo: this.createOrderAddressCode(),
      Access : this.createAccess(servicePeriodCode),
    }
    return obj;
  }

  createAccess(servicePeriodCode: string): CreateOrderAccess {
    let accessObj: CreateOrderAccess = {
      AgreementType: 'Invoiceable',
      PriceCode: this.membership,
      ServicePeriodCode: servicePeriodCode,
      IsUsageBased: false,
      Participants: [this.createParticipant()],
      IsEulaAccepted: true,
      OrderBy: this.createOrderAddressCode()
    }
    return accessObj;
  }

  createParticipant(): Participant {
    let obj: Participant = {
      CustomerNumber : this.customerNumber
    };
    return obj;
  }


  selectedCheckBox(val: any) {
    this.disableNextBtn = !val;
  }

  openTermsDialog(event: any) {
    this.termsDialogRef = this.dialog.open( this.paymentTermsDialog, {
      width: '1000px',
      height: 'auto'
    });
    event.preventDefault();
    event.stopPropagation();
  }

  acceptPaymentTerms() {
    this.acceptTerms = true;
    this.disableNextBtn = false;
    this.termsDialogRef.close();
  }

  nextAction() {
    if (this.orderNumber) {
      //console.log('Before encrypt call, this.orderNumber ' + this.orderNumber)
      this.orderService.encryptOrderNumber(this.orderNumber).
      subscribe({
        next: res => {
          //console.log('Response from encrypt call '+JSON.stringify(res))
          let resObj;
          try{
            resObj = JSON.parse(res);
          } catch (e) {
            resObj = JSON.parse(JSON.stringify(res));
          }
          //console.log ('resObj Data '+resObj.Data);
          if (resObj.Errors && resObj.Errors.length > 0) {
            this.alertService.displayError(resObj.ErrorMessage);
          } else {  
            //console.log('Before sending '+ encodeURIComponent(resObj.Data));
            window.location.href = environment.amaPayment + '?applnm=ocm&ordNumber=' + encodeURIComponent(resObj.Data) + 
             '&paramRtnUrl=' + environment.ocm + '/confirmation?orderNumber='; 
          }
        },
        error: error => {
          this.alertService.displayError(error.message);
        }  
      });      
    } else {
      this.alertService.displayError("There is no order created at this moment");
    }  
  }

  getTerm(term: string) {
    return term + ((term === '1') ? " Year": " Years");
  }  

  checkAndGetDetailsOfRenewalOrder() {
    if(this.products && this.products.length > 0) {
      let keys = Object.keys(this.products[0]);
      let product = this.products[0][keys[0]];
      this.isRenewalOrder = product.isRenewal ?? false;
      this.renewalAgreementId = product.agreementId ?? '';
      this.renewalQuantity = product.quantity;
      this.renewalItemNumber = keys[0];
    }
  }

  renewOrder() {
    let renewRequest = this.preRenewOrder();
    //call renew order service
    this.orderService.renewOrder(renewRequest).subscribe({ 
      next: (data: any) => {
        if(data) {
          if (data.Errors.length > 0) {
            this.alertService.displayError("Failed to Renew Subscription:" + data.ErrorMessage);
          } else {
            this.orderNumber = data.Data.OrderNumber;
            this.postRenewOrder();
          }
        } else {
          this.alertService.displayError("Error occured while calling renew order, no data returned");
          this.hasErrors = true;
          this.showSpinner = false;
        }
      },
      error: err => {
        console.log("Failed to renew subscription " + this.parseErrorMessage(err.ErrorMessage));
        const errorMsg = err.ErrorMessage.indexOf("has an unposted version") > -1 ? 
          "Current order still being processed. Please review and re-try tomorrow." : err.ErrorMessage;
        this.alertService.displayError(errorMsg);
        this.hasErrors = true;
        this.showSpinner = false;
      }
    }); 
  }

  preRenewOrder(): RenewOrderRequest {
    this.customerNumber = this.userService.profile.customerNumber;
    this.membership = this.userService.isInGroup('member') ? TierName.MEMBER : TierName.NONMBR;
    let req : RenewOrderRequest = {
      OrderSource : 'OCMWEB',
      BillTo: this.createOrderAddressCode(), 
      RateCode: this.membership,
      Quantity: this.renewalQuantity,
      AgreementId: this.renewalAgreementId
    }
    if(this.sharedDataService.promoCodes && this.sharedDataService.promoCodes.length > 0) {
      var promoCode = this.sharedDataService.promoCodes[0];
      req.PromotionCode = promoCode;
    }
    return req;
  }

  postRenewOrder() {
    this.sharedDataService.setOrderNumber(this.orderNumber, false);
    this.orderService.getOrder(this.orderNumber).subscribe({
      next: (data: any) => {
        if(data) {
          if(!data.Data)
            data = JSON.parse(data);
          this.retrieveDataFromResponse(data);
        } else {
          this.alertService.displayError("Error occured while calling retrieve order, no data returned");
          this.hasErrors = true;
          this.showSpinner = false;
        }
      },
      error: err => {
        this.alertService.displayError(this.parseErrorMessage(err.error.ErrorMessage));
        console.log("Error occured while calling retrieve order from Advantage" + this.parseErrorMessage(err.error.ErrorMessage));
        this.hasErrors = true;
        this.showSpinner = false;
      }
    }); 
    
  }
  private updateTrackingInfo() {
      const data: { dataKey: DataKeys; dataValue: any }[] = [];
      const producList = this.prodList;
      for(var prod of producList) {
        // data.push({dataKey: DataKeys.PRODUCT_NAME, dataValue: prod.productName});
        // data.push({dataKey: DataKeys.PRODUCT_ITEM_NUMBER, dataValue: prod.itemNumber});
        data.push({dataKey: DataKeys.QUANTITY, dataValue: prod.quantity});
      }
      data.push({dataKey: DataKeys.ORDER_NUMBER, dataValue: this.sharedDataService.orderNumber});
      data.push({dataKey: DataKeys.BILLING_EMAIL, dataValue: this.userEmail});
      let addr: Partial<BillingAddress> = this.sharedDataService.userAddress;
      if (addr) {
        data.push({dataKey: DataKeys.BILLING_FIRST_NAME, dataValue: addr.Address?.Name?.First});
        data.push({dataKey: DataKeys.BILLING_LAST_NAME, dataValue: addr.Address?.Name?.Last});
        data.push({dataKey: DataKeys.BILLING_COMPANY_NAME, dataValue: addr.Address?.Company});
        data.push({dataKey: DataKeys.BILLING_ADDRESS_LINE1, dataValue: addr.Address?.PostalAddress?.Line1});
        data.push({dataKey: DataKeys.BILLING_ADDRESS_LINE2, dataValue: addr.Address?.PostalAddress?.Line2});
        data.push({dataKey: DataKeys.BILLING_ADDRESS_CITY, dataValue: addr.Address?.PostalAddress?.City});
        data.push({dataKey: DataKeys.BILLING_ADDRESS_STATE, dataValue: addr.Address?.PostalAddress?.StateCode});
        data.push({dataKey: DataKeys.BILLING_ZIP_CODE, dataValue: addr.Address?.PostalAddress?.PostalCode});
        data.push({dataKey: DataKeys.BILLING_PHONE, dataValue: addr.Address?.Phone});
      }
      const filteredData = data.filter(item => item.dataValue !== "");
      this.trackingService.upsertFlow({
          customerNbr: this.userService.profile.customerNumber,
          ssoId: this.userService.profile.ssoId,
          data: filteredData,
          events: [{ trackingEvent: AbandonCartEvents.ORDER_REVIEW_STARTED }],
      });
    
    }
}
